import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  rows: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
    case actionTypes.CREATE:
    case actionTypes.UPDATE:
    case actionTypes.DELETE:
      return { ...state, isLoading: true };

    case actionTypes.GET_FULFILLED:
    case actionTypes.CREATE_FULFILLED:
    case actionTypes.UPDATE_FULFILLED:
    case actionTypes.DELETE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
      };

    case actionTypes.GET_REJECTED:
    case actionTypes.CREATE_REJECTED:
    case actionTypes.UPDATE_REJECTED:
    case actionTypes.DELETE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;

    default:
      return state;
  }
}
